import React from "react";

const ECONOMY_IDS = new Set(["economy-sedan", "crossover-suv", "minivan"]);
const ECONOMY_NAMES = new Set(["sedan", "crossover suv", "minivan"]);

export function isEconomy(vehicleId, vehicleName) {
  if (vehicleId && ECONOMY_IDS.has(vehicleId)) return true;
  return !!vehicleName && ECONOMY_NAMES.has(vehicleName.trim().toLowerCase());
}

// Small ECONOMY / LUXURY class pill. variant: "dark" (staff pages) | "light" (driver trip sheet)
export default function VehicleClassBadge({ vehicleId, vehicleName, variant = "dark", className = "" }) {
  if (!vehicleId && !vehicleName) return null;
  const economy = isEconomy(vehicleId, vehicleName);
  const styles = variant === "light"
    ? (economy ? "bg-sky-50 text-sky-700 border-sky-300" : "bg-amber-50 text-amber-800 border-amber-300")
    : (economy ? "bg-[#38BDF8]/10 text-[#38BDF8] border-[#38BDF8]/40" : "bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/40");
  return (
    <span
      data-testid="vehicle-class-badge"
      className={`inline-flex items-center shrink-0 border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.18em] leading-none ${styles} ${className}`}
    >
      {economy ? "Economy" : "Luxury"}
    </span>
  );
}
